
    import I18n from 'i18nObj';
    
      import 'translations/assignment_categories';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignment_categories');
  